import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const FormLayoutWidget: WidgetRegistryEntry = {
  name: "FormLayout",
  configuration: () => import("./configuration").then((x) => x.FormLayoutConfiguration),
  component: () => import("./form-layout-widget.component").then((x) => x.FormLayoutWidgetComponent)
};
